export default __webpack_public_path__ + "static/media/laranja.87410889.png";